<template>
  <div class="content">
    <div class="search-box justify-align" ref="getheight">
      <img @click="onClickLeft" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="" />
      <div class="search-box-sec left-justifying">
        <img :src="require('../../assets/'+appTheme+'/search_icon.png')" alt="" />
        <div class="searchInput" type="text" @click="onSearch">搜一搜 </div>
      </div>
    </div>
    <div class="content-cate">
      <van-tree-select :height="wh" :items="items" :main-active-index.sync="active" @click-nav="clickNav">
        <template #content>
          <div class="classify-box">
            <van-swipe class="my-swipe" :autoplay="4000" indicator-color="white">
              <van-swipe-item v-for="(item,index) in bannerList" :key="index" @click="clickDes(item.url)"><img class="cover-img" :src="item.image" /></van-swipe-item>
            </van-swipe>
            <div class="shop-box">
              <!--              <div class="down-time" v-if="msTxtShow==false"><span>{{showTime.H}}</span>：<span>{{showTime.M}}</span> ：<span>{{showTime.S}}</span></div>-->
              <!--              <div  class="down-time" style="color: #F23926;font-weight: bold;" v-else>秒杀中</div>-->
              <div class="f-title-box justify-align">
                <div class="f-title">爆款商品</div>
                <div class="left-justifying f-title-right" v-if="show_status == 1">
                  <img :src="require('../../assets/'+appTheme+'/z_icon.png')" alt="" /><div> <span>{{full_time}}</span> 开抢</div>
                </div>
              </div>
              <div class="shop-list">
                <div v-for="(item,index) in oneList" :key="index">
                  <div class="shop-item left-justifying" v-for="(good,index) in item.onepay_goods" :key="index">
                    <img class="shop-img" @click="goDesGood(good.goods_id,good.id,good.useful_stock)" :src="good.goods.image" alt="">
                    <div class="content-item">
                      <div class="title" @click="goDesGood(good.goods_id,good.id,good.useful_stock)"> <span class="tag" v-if="item.isMs==1&&good.useful_stock != 0">￥{{good.price}}</span> {{good.goods.name}}</div>
                      <div class="item-bottom justify-align">
                        <div class="price" @click="goDesGood(good.goods_id,good.id,good.useful_stock)" v-if="item.isMs==1&&good.useful_stock != 0" :style="{color: (item.isMs==1&&good.useful_stock != 0?'#F23926':'#9ed68e')}">￥{{good.price}}</div>
                        <div class="price" @click="goDesGood(good.goods_id,good.id,good.useful_stock)" v-else style="color:#9ed68e;">￥{{good.goods.price}}</div>
                        <div class="rt-box left-justifying">
                          <img @click="shareClick(good)" :src="require('../../assets/'+appTheme+'/share_icon2.png')" alt="" />
                          <div class="btn" @click="goDesGood(good.goods_id,good.id,good.useful_stock)">马上抢</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </template>
      </van-tree-select>
    </div>
    <!--    分享弹框-->
    <van-overlay :show="shareShow">
      <div class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <img v-if="shareItem" class="img-goods goodsImg" :src="shareItem.goods.image" alt="" />
          <div class="title">{{shareItem.name}}</div>
          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>
      </div>
    </van-overlay>
    <!-- 分享弹框end -->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { VueCanvasPoster } from 'vue-canvas-poster'
import {getWechat} from "@/api/zhibo";
const jweixin = require('jweixin-module');
export default {
  name: "oneYuan",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      shareShow:false,
      searchValue: '',
      active: 0,
      items: [{id:1,text:'￥1精品'}],
      currItem: '',
      curr: 0,
      wh:'500px',
      oneList:[],
      bannerList:[],
      currImg:'',
      full_time:'',
      msTxtShow: false, // false:显示倒计时  true：显示秒杀中
      endTime:'2021-10-15 15:58',
      finishedTime: '', // 活动结束时间
      showTime: {
        H: 0,
        M: 0,
        S: 0
      }, //倒计时
      msIsShow: false, // 判断秒杀是否显示
      colorMs: false, // 当天有秒杀 颜色为红色 别的为灰色
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      painting:{
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px'
      },
      pic: '',
      show_status: 1 // 1 显示 0 时隐藏
    }
  },
  components: {
    VueCanvasPoster
  },
  destroyed() {
    //移除事件处理程序
    window.removeEventListener("pagehide", this.pageHide);
  },
  mounted(){
    window.addEventListener("pagehide", this.pageHide);
    window.addEventListener("pagehide", this.pageHide);
    this.$nextTick(()=>{ // 页面渲染完成后的回调
      var heightCss = this.$refs.getheight.offsetHeight;
      console.log(heightCss)
      let wh = document.documentElement.clientHeight
      this.wh = (wh-heightCss) + 'px'
    })
  },
  created() {
    // this.getCategory()
    let http = window.location.protocol+'//'
    let url = window.location.hostname // 获取当前访问（域名）
    this.pic = http+url+'/logo.jpg' //'https://jpzs-zst.itos.cn/logo.jpg'
    this.getOnePayData()
    this.getAd()
  },
  methods: {
    shareShowHide(){
      this.shareItem = ''
      this.shareGoodsImg = ''
      this.qrcodeUrl = ''
      this.shareShow = false
      console.log(this.qrcodeUrl)
      console.log('shareItem',this.shareItem)
    },
    shareClick(goods){ // 生成二维码
      console.log(goods)
      this.shareItem = goods
      this.shareGoodsImg = goods.goods.image
      var id = goods.goods_id
      let baseUrl = ''
      // if (process.env.VUE_APP_MODE === 'development') {
      //   // 开发环境下的执行操作  http://localhost.itos.cn/goodDetails?id=524
      //   baseUrl = `https://jpzs-zst.itos.cn/goodDetails?id=${id}`
      // } else {
      //   // 生产环境下的执行操作 https://jpzs-zst.itos.cn/goodDetails?id=750
      //   baseUrl = `https://jpzs-zst.itos.cn/goodDetails?id=${id}`
      // }
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/goodDetails?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
      // console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          this.qrcodeUrl = qr;
          console.log(this.qrcodeUrl)
          this.shareShow = true
          // this.imageUrlToBase64(goods.image)
          // this.drawCanvas();
          this.drawPoster()
        }
      });

    },
    drawPoster(){
      console.log('shareItem',this.shareGoodsImg)
      var total = this.shareItem.goods.price * 0.95
      var price = total.toFixed(2);
      var discount = '折后优惠价：'+price
      this.painting = {
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '502px',
              height: '876px',
              right: '9px',
              bottom: '6px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#FDD80D',
            }
          },
          {
            type: 'image',
            url: this.shareGoodsImg,// this.shareGoodsImg, // 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '370px',
              height: '370px',
              top: '30px',
              left: '75px'
            }
          },
          {
            type: 'text',
            text: this.shareItem.goods.name,
            css: [
              {
                top: '430px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '26px'
              }
            ]
          },
          {
            type: 'image',
            url: this.qrcodeUrl,
            css: {
              width: '170px',
              height: '170px',
              top: '530px',
              left: '175px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "720px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
              color: '#E43A0D'
            }
          },
          // {
          //   type: 'rect',
          //   css: {
          //     width: '503px',
          //     height: '106px',
          //     right: '9px',
          //     bottom: '70px',
          //     color: '#feeb86',
          //
          //   }
          // },
          // {
          //   type: "text",
          //   text: "扫码购买立即享受95折",
          //   css: {
          //     bottom: "135px",
          //     left: "136px",
          //     width: "360px",
          //     maxLines:1,
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
          // {
          //   type: "text",
          //   text: discount, // 扫码购买立即享受95折 折后优惠价：15.2
          //   css: {
          //     bottom: "90px",
          //     left: "134px",
          //     width: "260px",
          //     maxLines:1,
          //     textAlign: 'center',
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
        ]
      }
    },
    //成功生成海报
    success(src) {
      this.posterUrl = src;
      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
    clickDes(url){ // 详情页
      // console.log(url)
      var url = url
      if (url != null){
        window.open(url)
        // console.log(url)
      }
    },
    async getAd(){
      var data = {
        code: 'onepayCategory'
      }
      const res = await this.$Http.getAdv(data)
      if (res.code==200){
          this.bannerList = res.data
        // if (res.data.length>0){
        //   var arr  = res.data
        //   // 根据背景图数组的长度随机选择索引
        //   const randIndex = Math.floor(Math.random() * arr.length)
        //   this.currImg = arr[randIndex].image
        // } else {
        //   // this.$router.push('/');
        // }
      }else {
        this.$toast(res.message)
      }
    },
    async getOnePayData() { // 获取一元购
      const res = await this.$Http.getOnePay()
      if (res.code==200){
        var arr = res.data
        let nowTime = this.getTime(0) // 当前时间日期
        for( var i=0; i < arr.length; i++){ // 添加秒杀判断
          if (arr[i].date == nowTime ){
            arr[i].isMs = 1
          } else {
            arr[i].isMs = 0
          }
        }
        this.oneList = arr
        this.full_time =arr[0].tips_time
        this.show_status = arr[0].show_status
        this.endTime = arr[0].full_time
        this.currItem = arr[0].onepay_goods[0]
        //  判断是否在秒杀中解决后退
        let nowTimeCurr = new Date().getTime(); // 当前时间
        let startDate = arr[0].full_time; // 四点钟倒计时
        startDate = startDate.replace(new RegExp('-', 'gm'), '/');
        let startDateM = new Date(startDate).getTime(); //得到毫秒数
        // console.log('startDate',startDate)
        let lefttime = startDateM - nowTimeCurr;
        if (lefttime > 0) { // 倒计时中
          this.msTxtShow = false //  false:显示倒计时  true：显示秒杀中
        }else {
          this.msTxtShow = true
        }
        //  判断是否在秒杀中解决后退end
        if (this.show_status ==1){ //show_status 1时隐藏
          this.showTimes()
        }
        this.getShareInfo()
      } else {
        this.$toast(res.message)
      }
      // console.log(res)
    },
    //页面关闭或刷新时触发
    pageHide() {
      this.$store.commit("setWechatSignUrl", '');
    },
    getShareInfo(){
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        // console.log('ios')
      } else {
        // console.log('安卓')
        pageUrl = location.href.split('#')[0]
      }

      const data = {
        liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
      }
      // console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          let weChat = res.data
          // console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['checkJsApi','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            const that = this
            // console.log('ready',that.desShare)
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              //是否支持分享
              jweixin.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
                success: function (res) {
                  console.log(res)
                }
              });
              let urlPath = location.href.split('#')[0]
              // alert("准备完毕，加载方法");
              //分享到朋友圈
              jweixin.updateTimelineShareData({
                title: '1元精品',   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.pic,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              });
              jweixin.onMenuShareTimeline({ // 旧版本
                title: '1元精品',   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.pic,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              })
              //分享给朋友
              jweixin.updateAppMessageShareData({
                title: '1元精品',
                desc:'比拼多多最低还要低',
                link: urlPath, // keyi
                imgUrl: that.pic,
                success: function (n) {
                  console.log("分享成功", n);
                },
                complete: function (n) {
                  console.log(n);
                }
              });

              // 旧版本
              jweixin.onMenuShareAppMessage({
                title: '1元精品', // 分享标题
                desc:'比拼多多最低还要低', // 分享描述
                link: urlPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: that.pic, // 分享图标
                success: function (e) {
                  // 用户点击了分享后执行的回调函数
                  console.log('分享给朋友',e);
                }
              });


            })
          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    getTime(val) { //   获取时间并格式化
      // 获取前val天的时间
      var dt = new Date;
      val === 0 ? '' : dt.setTime(dt.getTime() + 24 * 60 * 60 * 1000 * val)
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");
      return `${y}-${m}-${d}`;  // 获取的时间格式为 2021-04-09 09:34:00
    },
    showTimes(val) {
      let that = this;
      let interval = setInterval(() => {
        let nowTime = new Date().getTime(); // 当前时间
        let startDate = that.endTime; // 四点钟倒计时
        startDate = startDate.replace(new RegExp('-', 'gm'), '/');
        let startDateM = new Date(startDate).getTime(); //得到毫秒数
        // console.log('startDate',startDate)
        let lefttime = startDateM - nowTime;
        if (lefttime > 0) { // 倒计时中
          that.showTime.H = Math.floor(lefttime / (1000 * 60 * 60)) < 10 ? '0' + Math.floor(lefttime / (1000 * 60 * 60)) : Math.floor(lefttime / (1000 * 60 * 60)); //计算小时数
          that.showTime.M = Math.floor((lefttime / (1000 * 60)) % 60) < 10 ? '0' + Math.floor((lefttime / (1000 * 60)) % 60) : Math.floor((lefttime / (1000 * 60)) % 60); //计算分钟数
          that.showTime.S = Math.floor((lefttime / 1000) % 60) < 10 ? '0' + Math.floor((lefttime / 1000) % 60) : Math.floor((lefttime / 1000) % 60); //计算秒数
          this.msTxtShow = false //  false:显示倒计时  true：显示秒杀中
        } else { // 秒杀时间<=现在<次日0点：秒杀中
          console.log('秒杀中')
          this.msTxtShow = true
          // this.msTxtShow = true //  false:显示倒计时  true：显示秒杀中
          that.showTime.H = '00';
          that.showTime.M = '00';
          that.showTime.S = '00';
          clearInterval(interval);
        }
      }, 1000);
    },
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    async getCategory () { // 分类
      const res = await this.$Http.getCategoryList()
      if (res.code == 200){
        console.log('res',res)
        var arr = res.data
        var arr = JSON.parse(JSON.stringify(arr).replace(/name/g,'text'))

      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    clickNav(index){
      console.log(index)
      this.curr = index
      this.currItem = this.items[index]
      // this.bannerList = this.items[index].banners
    },
    onSearch(){
      this.$router.push({path:'/searchList'})
    },
    goDes(id){
      this.$router.push({path:'/classifyList',query: {id:id}})
    },
    goDesGood(gid,tid,isPay){
      console.log('库存',isPay)
      console.log('msTxtShow',this.msTxtShow)
      var useful_stock = isPay // 是否秒杀有库存
      console.log(isPay)
      if (this.msTxtShow == true && useful_stock != 0){ // 一元秒杀中
        this.$router.push({path:'/goodDetails',query:{id:gid,type:tid,isPay:isPay}})
      } else {
        this.$router.push({path:'/goodDetails',query:{id:gid}})
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 80px auto 30px;
  }
  img{
    width: 520px;display: block;height: auto;margin: 0 auto;
  }
}
.van-tree-select__nav {
  webkit-box-flex: 0.75;
  -webkit-flex: 0.75;
  flex: 0.75;
}
.search-box{
  padding: 34px 42px 34px 27px;
  background: #FDD80D;
  img{
    width: 22px;height: auto;display: inline-block;
  }
  .search-box-sec{
    width: 590px;
    height: 60px;
    line-height: 60px;color: #8C8C8C;font-size: 24px;
    background: #FFFFFF;
    opacity: 0.63;
    border-radius: 30px;text-align: left;padding-left: 28px;
    img{
      width: 34px;height: auto;display: inline-block;
    }
    .searchInput{
      height: 60px;
      line-height: 60px;width: 500px;margin-left: 10px;border: none;background: none;color: #282828;font-size: 28px;
    }
  }
}
.van-sidebar-item--select::before {
  top: 0;height: 100%;
  background-color: #f7f8fa;width: 0px;
}
.van-tree-select{
  color: #282828;font-size: 30px;
}
.van-sidebar-item--select, .van-sidebar-item--select:active {
  font-size: 32px;
  font-weight: bold;border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  margin-left: 20px;
}
.my-swipe {
  width: 480px;margin: 0 auto;
  .van-swipe-item{
    width: 480px;
    height: 177px;overflow: hidden;
  }
}
.classify-box{
  padding-top: 20px;
  .cover-img{
    width: 100%;
    height: 177px;
    border-radius: 12px;
  }
}
.shop-box{
  font-size: 26px;
  .f-title-box{
    padding: 20px 24px;
    .f-title{
      text-align: left;font-size: 30px;color: #282828;
    }
    .f-title-right{
      font-weight: bold;
      color: #282828;font-size: 22px;
      span{
        color: #F23926;
      }
      img{
       margin-right: 10px;height: auto;display: block;width: 22px;
      }
    }
  }

  .shop-list{
    //-ms-flex-wrap: wrap;
    //flex-wrap: wrap;
    //display: -webkit-box;
    //display: -ms-flexbox;
    //display: flex;
    padding: 0 15px;
    .shop-item{
     text-align: center;padding-bottom: 38px;border-bottom: 1px solid #E8E8E7;margin-bottom: 10px;padding-top: 26px;
      img{
        width: 120px;
        height: 120px;
        border-radius: 10px;margin-right: 15px;
      }
      .content-item{
          width: 375px;
        .title{
          font-size: 24px;text-align: left;color: #000000;line-height: 40px;
          span{
            padding: 2px 5px;background: #F23926;
            border-radius: 5px;font-size: 18px;font-weight: bold;
            color: #FFFFFF;
          }
        }
        .item-bottom{
          .price{
            font-size: 26px;font-weight: bold;
            color: #F23926;
          }
          .rt-box{
            img{
              width: 29px;height: auto;display: inline-block;margin-right:25px;
            }
            .btn{
              background: #FDD80D;
              border-radius: 25px;font-size: 22px;padding: 8px 18px;
              font-weight: bold;
              color: #F23926;
            }
          }
        }
      }

    }
  }
}
</style>
